/**
 * dcent-scroll-lock.js — 배경 스크롤 잠금 (drop-03 W0).
 *
 * 원본: ~/work/homepage-design-src/src/scrollLock.ts (13줄).
 * **카운터 방식 필수** — 각 모달이 저장/복원을 따로 하면 중첩 모달(검색 모달 위 코인 상세)에서
 * 닫는 순서에 따라 body 에 `overflow:hidden` 이 남는다.
 *
 * 소비 계약(정규 경로 = 전역):
 *   <script src="{{ 'dcent-scroll-lock.js' | asset_url }}" type="module" defer></script>
 *   window.DcentScrollLock.lock();    // 모달 열 때 (카운터 +1)
 *   window.DcentScrollLock.unlock();  // 닫을 때   (카운터 -1)
 *
 * 멱등 설치 — 상태(count)를 window 객체에 얹어 모듈이 두 번 평가돼도 카운터가 한 벌이 되게 한다.
 * `if (window.X) return;` 관용구를 쓰지 않는다: 이 파일은 type="module" 로 로드되고
 * ESM 최상위 return 은 SyntaxError: Illegal return statement 라 파일 전체가 죽는다.
 *
 * ESM import 관용구는 이 테마에 선례가 0건이라(Liquid asset_url 을 import 에 넣을 수 없다)
 * 소비처의 정규 경로는 전역이다. named export 는 단위 테스트·타입 힌트용 얇은 래퍼다.
 *
 * 양 샵 byte-identical — assets/dcent-* 는 parity 게이트 분모다.
 */

if (!window.DcentScrollLock) {
  let count = 0;

  window.DcentScrollLock = {
    lock() {
      count += 1;
      if (count === 1) document.body.style.overflow = "hidden";
    },
    unlock() {
      count = Math.max(0, count - 1);
      if (count === 0) document.body.style.overflow = "";
    },
    /** 중첩 복구용 안전밸브 — 원본에 없는 유일한 추가. */
    reset() {
      count = 0;
      document.body.style.overflow = "";
    },
    get count() {
      return count;
    },
  };
}

export function lockBodyScroll() {
  window.DcentScrollLock.lock();
}

export function unlockBodyScroll() {
  window.DcentScrollLock.unlock();
}
